<template>
    <card>
        <h3 class="mb-0" slot="header">{{ $t('common.password') }}</h3>

        <validation-observer v-slot="{ invalid, handleSubmit }" ref="passwordValidator">
            <form @submit.prevent="handleSubmit(submit)" @keydown="form.errors.clear($event.target.name)">

                <base-input class="mb-3"
                    type="password"
                    :label="$t('auth.current-password')"
                    label-classes="form-control-label required"
                    :placeholder="$t('auth.current-password')"
                    v-model="form.data.current_password"
                    name="current_password"
                    :rules="{required: true, min: 8}"
                    :error="form.errors.get('current_password')"
                >
                </base-input>

                <base-input class="mb-3"
                    type="password"
                    :label="$t('auth.new-password')"
                    label-classes="form-control-label required"
                    :placeholder="$t('auth.new-password')"
                    v-model="form.data.new_password"
                    name="new_password"
                    :rules="{required: true, min: 8}"
                    :error="form.errors.get('new_password')"
                >
                </base-input>

                <base-input class="mb-3"
                    type="password"
                    :label="$t('auth.new-password-confirm')"
                    label-classes="form-control-label required"
                    :placeholder="$t('auth.new-password-confirm')"
                    v-model="form.data.new_password_confirmation"
                    name="new_password_confirmation"
                    :rules="{required: true, min: 8, confirmed: 'new_password'}"
                    :error="form.errors.get('new_password_confirmation')"
                >
                </base-input>

                <div class="category form-category mb-4">
                    <small><span class="text-warning">*</span> {{ $t('common.required-fields') }}</small>
                </div>

                <div class="text-center">
                    <base-button native-type="submit"
                        type="primary"
                        :disabled="form.errors.any() || invalid"
                        :loading="form.recording"
                    >
                        {{ $t('auth.change-password') }}
                    </base-button>
                </div>

            </form>
        </validation-observer>
    </card>
</template>

<script>
    import CrudClient from '@trax/classes/CrudClient'
    import CrudForm from '@trax/classes/CrudForm'

    export default {

        data() {
            let client = new CrudClient('/trax/api/front/users/me/password')
            return {
                form: new CrudForm(client, this.mapData, this.unmapData),
            }
        },

        created() {
            this.form.errors.setValidator('passwordValidator', this)
            this.form.create().then(this.succeeded)
        },

        methods: {

            mapData(user) {
                return {
                    current_password: null,
                    new_password: null,
                    new_password_confirmation: null,
                }
            },

            unmapData(data) {
                return data
            },

            submit() {
                this.form.created()
            },

            succeeded() {
                this.$notify({type: 'primary', message: this.$t('auth.password-changed') })
                this.form.create().then(this.succeeded)
            }
        }
    }
</script>

